namespace SP {
    export enum UnitType {
        pcs = 0,
        m = 1,
        cm = 2,
        mm = 3,
        t = 4,
        kg = 5,
        g = 6,
        lb = 7,
        oz = 8,
        l = 9,
        ml = 10
    }
}